/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyQuetzal = createReactComponent("outline", "currency-quetzal", "IconCurrencyQuetzal", [["path", { "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M13 13l5 5", "key": "svg-1" }]]);

export { IconCurrencyQuetzal as default };
//# sourceMappingURL=IconCurrencyQuetzal.mjs.map
